import { deviceManagementPrivateNavigation } from '../domain/navigation-private';

export default deviceManagementPrivateNavigation;
